export default __webpack_public_path__ + "static/media/xsushi.2161de3d.png";